import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Spinner } from 'reactstrap';

import useApi from 'hooks/useApi';
import { selectCurrentClient } from 'redux/actions/clientActions';
import { documentFailure } from 'redux/actions/documentActions';

import { colors, fonts } from 'shared/defaultTheme';

import { Ul, ClientsWrapper } from '../styles';

const Clients = ({ searchValue }) => {
  const { customAreaApi } = useApi();
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme);
  const { cusNavId } = useSelector((state) => state.auth);
  const { currentClient } = useSelector((state) => state.clientState);
  const { mainColor } = theme;
  const [clientList, setClientList] = useState([]);

  const [{ loading }, getClientsData] = customAreaApi(
    {
      url: `${window.API_V1}/cli/clients/${cusNavId}/search`,
      method: 'POST',
    },
    { manual: true }
  );

  const clientsData = async () => {
    const {
      data: { data },
    } = await getClientsData({
      data: {
        filters: [
          {
            model: 'Client',
            field: 'ClientName',
            asc: true,
          },
        ],
        reduce: {
          limit: 0,
          skip: 0,
        },
      },
    });
    setClientList(data);
    dispatch(selectCurrentClient(currentClient || data[0]));
  };

  useEffect(() => {
    clientsData();
  }, []);

  const searchClients = async () => {
    try {
      const {
        data: { data },
      } = await getClientsData({
        data: {
          filters: [
            {
              model: 'Client',
              field: 'ClientName',
              filter: [searchValue],
              isRegex: true,
            },
            {
              model: 'Client',
              field: 'ClientName',
              asc: true,
            },
          ],
          reduce: {
            limit: 0,
            skip: 0,
          },
        },
      });
      setClientList(data);
    } catch (error) {
      setClientList([]);
    }
  };

  useEffect(() => {
    if (searchValue != null && searchValue.length >= 2 && !loading) {
      searchClients();
    }
    if (searchValue != null && searchValue.length < 1 && !loading) {
      searchClients();
    }
  }, [searchValue]);

  const onSelectClient = (client) => {
    dispatch(selectCurrentClient(client));
    dispatch(documentFailure(null));
  };

  return (
    <ClientsWrapper>
      <Ul className="list-unstyled">
        {!loading ? (
          <>
            {clientList.map((client) => (
              <Li
                key={client.clientId}
                onClick={() => onSelectClient(client)}
                selectedColor={
                  currentClient?.clientId === client.clientId ? colors.whiteSmoke : colors.white
                }
              >
                <Div>{client.clientName}</Div>
              </Li>
            ))}
          </>
        ) : (
          <div className="d-flex justify-content-center mb-5 align-items-center h-100">
            <Spinner color={mainColor} />
          </div>
        )}
      </Ul>
    </ClientsWrapper>
  );
};

const Div = styled.div`
  width: 100%;
  height: 45px;
  cursor: pointer;
  padding: 15px;
  font-family: ${fonts.default};
  font-size: 14px;
  font-weight: bold;
`;

const Li = styled.li`
  background: ${({ selectedColor }) => selectedColor};
  &:hover {
    background: ${colors.whiteSmoke};
  }
`;

Clients.defaultProps = {
  searchValue: undefined,
};

Clients.propTypes = {
  searchValue: PropTypes.string,
};

export default Clients;
